module.exports = __webpack_public_path__ + "static/img/Group 1475@2x.d3123de6.png";